"use client";
import * as React from "react";
const SvgLiveTvOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M5.82 5.6v5.6l5.09-2.8zm8.73-2.8H9.03l2.4-2.3-.52-.5L8 2.8h-.02L5.07 0l-.5.5 2.38 2.3h-5.5C.66 2.8 0 3.43 0 4.2v8.4c0 .77.66 1.4 1.46 1.4h13.09c.8 0 1.45-.63 1.45-1.4V4.2c0-.77-.65-1.4-1.45-1.4m0 9.8H1.45V4.2h13.1z" }));
export {
  SvgLiveTvOutlined as default
};
